<template>
    <span class="text-danger">
        <i
            class="fa fa-ban fa-lg icon-button"
            title="Marcar como reprovada"
            @click.stop="confirmarReprovacao()"
        ></i>
    </span>
</template>

<script>
export default {
    props: {
        solicitacaoAditivo: {
            type: Object,
            default: () => {}
        },

        solicitacoesAditivosServicos: {
            type: Object,
            default: () => {}
        }
    },

    data() {
        return {}
    },

    methods: {
        confirmarReprovacao() {
            this.$swal({
                title: 'Solicitação de Aditivo Reprovada',
                html: `Confirma a REPROVAÇÃO da solicitação de aditivo da contratação ${this.solicitacaoAditivo.codContratacao}?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não',
                input: 'textarea',
                inputPlaceholder: 'Informe a justificativa da reprovação',
                inputValidator: value => {
                    if (!value) {
                        return 'A justificativa da reprovação é obrigatória'
                    }
                }
            }).then(result => {
                if (result.value) {
                    this.reprovar(result.value)
                }
            })
        },

        reprovar(justificativa) {
            this.$store.dispatch('addRequest')
            let solicitacaoAditivoReprovadaDto = {
                solicitacaoAditivoId: this.solicitacaoAditivo
                    .solicitacaoAditivoId,
                detalheReprovacao: justificativa
            }
            this.solicitacoesAditivosServicos
                .reprovar(solicitacaoAditivoReprovadaDto)
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Solicitação de aditivo reprovada com sucesso',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$emit('atualizar-listagem')
                        } else {
                            this.$toast.error(
                                'Falha ao atualizar a solicitação do aditivo',
                                'ERRO',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        }
    }
}
</script>
